import Tabs from '@scripts/modules/Tab';

const productsTabs = Tabs({
    tabs: '.product-tabs .tab',
    content: '.tab_content'
})